import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
import { SubmitgyanService } from './../../core/services/submit-gyan/submitgyan.service';
import { Component, ViewChild, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { Options } from '@angular-slider/ngx-slider';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from '@angular/forms';
import { CreateGyanService } from 'src/app/core/services/create-gyan/create-gyan.service';
@Component({
    selector: 'app-submit-gyan',
    templateUrl: './submit-gyan.component.html',
    styleUrls: ['./submit-gyan.component.scss'],
})
export class SubmitGyanComponent {
    faAngleUp = faAngleUp;
    faAngleDown = faAngleDown;
    @ViewChild('accordianArticle') accordianArticle: any;
    @ViewChild('accordianQuerySpecific') accordianQuerySpecific: any;
    @ViewChild('accordianAbstract') accordianAbstract: any;
    @ViewChild('accordianGenerative') accordianGenerative: any;
    @ViewChild('saveDraftModal') saveDraftModal!: TemplateRef<any>;

    value: number = 50;
    options: Options = {
        showTicksValues: true,
        stepsArray: [{ value: 5 }, { value: 10 }, { value: 25 }, { value: 50 }, { value: 75 }, { value: 100 }],
    };

    // library: any;
    // masterSelected: any;
    checkedList: any;
    isMobile = false;
    google = false; //Changed it from true to false
    webURL: any;
    IgnorewebURL: any; // Array that should be Ignored
    webURLArray: any; // Array that should be prioritised
    ignorewebURLArray: any; // Final Array that should be Ignored
    selectedWebURLArray: any; //Final Array that should be prioritised
    selectedIgnoreWebURLArray: any;
    prioritizeDomains: any;
    deprioritizeDomains: any;
    searchStr = '';
    maxSearchCount: any;
    maxSearchCountRepo: any;
    isLoading = true;
    disableSubmit = true;
    displayTooltip = false;
    advancedGyanMessage =
        'Enter your Gyan research query and specify any number of sources in the categories below. Specify your query as a hierarchy of topics if you want the results hierarchically organized into "chapters".';

    private showAdvancyQueryFormPage: Subscription;
    private validationForSubmitGyanFromSubtopic: Subscription;

    googleChecked = true;
    draftname: string = '';
    flagValue: boolean = true;
    isDrafLoaded: boolean = false;
    draft: any;
    // sharedLibrary: any;
    // myLibrary: any;
    // myKnowledgeStoreArray = [];
    // myKnowledgeStoreData: any;
    // myKnowledgeStoreSelected: any;
    // checkedListMyKnowledgeStore: any;

    //dynamicForm: FormArray = this.fb.array([]);
    keys: Array<string> = [];
    response: any = {};
    checkedRepoIds: Array<string> = [];
    // minDateTo: string = '';
    // maxDateFrom: string = '';
    private callTopicName: Subscription;
    private draftItem: Subscription;
    private resetGyan: Subscription;
    showPKSPermission: boolean = false;

    GyanKnowledgeStorePermission: boolean = false;
    MyKnowledgeStorePermission: boolean = false;
    WebSourcePermission: boolean = false;
    cancelFlag: string = '';
    private modalRef: NgbModalRef | undefined;

    getTemplateSubsTopicOutline: Subscription;
    getTemplateSubsSources: Subscription;
    getTemplateSubsConfig: Subscription;

    constructor(
        private toastr: ToastrService,
        private submitgyanService: SubmitgyanService,
        private authservice: AuthService,
        private commonservice: CommonServiceService,
        private localStorageService: LocalStorageService,
        private cd: ChangeDetectorRef,
        private modalService: NgbModal,
        private fb: FormBuilder,
        private creategyanservice: CreateGyanService,
    ) {
        this.checkWidth();
        this.creategyanservice.pksSelected = false;
        this.checkedList = [];
        this.webURLArray = [];
        this.ignorewebURLArray = [];
        this.selectedWebURLArray = [];
        this.selectedIgnoreWebURLArray = [];
        this.prioritizeDomains = [];
        this.deprioritizeDomains = [];

        //calling subject to load Advance Query form
        this.showAdvancyQueryFormPage = this.commonservice.showAdvancyQueryFormPage$.subscribe((value) => {
            if (value) {
                //should be removed when save draft implemented
                // this.commonservice.setTemplateDataSubject({});
                // this.commonservice.setTemplateDataSubjectForSources({});
                // this.commonservice.setTemplateDataSubjectForTopicOutline({});
                // this.commonservice.setTemplateDataSubjectForConfig({});

                const gyanData = this.localStorageService.getItem('gyanData');
                this.searchStr = gyanData.gyanName;
            }
        });

        //checking gyan-input gyan topic name to show submit button active
        this.callTopicName = this.commonservice.callTopicName$.subscribe((value) => {
            //   console.log(value);
            this.searchStr = value;
            const topicOutline = this.localStorageService.getItem('topicOutline');
            //console.log('-------------', topicOutline?.name);
            if (topicOutline?.name) this.searchStr = topicOutline.name;
            else {
                this.searchStr = value;
            }
        });

        //checking validation from another component
        this.validationForSubmitGyanFromSubtopic = this.commonservice.validationForSubmitGyanFromSubtopic$.subscribe((value) => {
            if (value) {
                this.checksubmitGyanButtonValidation();
            }
        });

        //for use as template

        this.getTemplateSubsTopicOutline = this.commonservice.templateDataSubjectForTopicOutline$.subscribe((topicOutline: any) => {
            if (topicOutline) {
                console.log('topicOutline', topicOutline);
                this.searchStr = topicOutline.name;
            }
        });

        this.getTemplateSubsSources = this.commonservice.templateDataSubjectForSources$.subscribe((sources: any) => {
            if (sources) {
                console.log('sources is', sources);
                localStorage.setItem('sources', JSON.stringify(sources));
                if (sources.favouriteWebsites) {
                    this.webURLArray = sources.favouriteWebsites;
                    this.selectedWebURLArray = this.webURLArray;
                    this.google = this.webURLArray?.includes('https://www.google.com') || this.webURLArray?.includes('https://www.google.com/');
                }
                if (sources.dispreferredWebsites) {
                    this.ignorewebURLArray = sources.dispreferredWebsites;
                }
                this.updateLocalDataforUrls();
            }
        });

        this.getTemplateSubsConfig = this.commonservice.templateDataSubjectForConfig$.subscribe((config: any) => {
            if (config) {
                console.log('---config---', config);
                this.value = parseInt(config.maxSearchCount) + parseInt(config.maxSearchCountRepo);
                console.log('---this.value---', this.value);
                //  this.maxSearchCount = config.maxSearchCount;
                //  this.maxSearchCountRepo = config.maxSearchCountRepo;
            }
        });

        this.resetGyan = this.commonservice.cancelFlag$.subscribe((flag) => {
            if (flag) {
                this.clearLocalStorageData();
                this.flagValue = false;
                this.webURLArray = [];
                this.ignorewebURLArray = [];
                this.google = false;
            }
        });

        this.draftItem = this.commonservice.calldraftLoaded$.subscribe((data) => {
            if (data !== null) {
                this.isDrafLoaded = true;
                this.draft = data;
                this.draftname = data?.name;
            }
        });
    }

    ngOnInit() {
        this.getAccessPermission();
        this.showPKSPermission = this.authservice.getAccessList('ShowPKS');
        if (!this.showPKSPermission) {
            console.log('it is coming inside pks true');
            this.webURLArray = ['https://www.google.com'];
            this.google = true;
            this.selectedWebURLArray = ['https://www.google.com']; // for default selected google checkbox
            this.prioritizeDomains = ['https://www.google.com'];
            if (this.searchStr !== '') this.updateLocalStorage();
            this.cd.detectChanges();
        }
        setTimeout(() => {
            this.isLoading = false;
        }, 2000);

        // if (this.cancelFlag) {
        //     this.clearLocalStorageData();
        // }
        //this.clearLocalStorageData();

        //submit button enabled
        const topicOutline = this.localStorageService.getItem('topicOutline');
        //console.log('-------------', topicOutline?.name);
        if (topicOutline?.name) this.searchStr = topicOutline.name;
        if (this.localStorageService.getItem('sliderRange') && this.searchStr !== '') {
            this.value = this.localStorageService.getItem('sliderRange');
        }
        this.updateLocalDataforUrls();
        //alert(this.value)
    }

    updateLocalDataforUrls() {
        const sources = this.localStorageService.getItem('sources');
        if (sources && this.searchStr !== '') {
            this.webURLArray = sources.favouriteWebsites;
            if (this.webURLArray.includes('https://www.google.com')) {
                this.google = true;
            }
            this.ignorewebURLArray = sources.dispreferredWebsites;
            this.selectedWebURLArray = this.webURLArray;
            //this.ignorewebURLArray = this.ignorewebURLArray;
        }
    }

    getAccessPermission() {
        this.GyanKnowledgeStorePermission = this.authservice.getAccessList('KnowledgeStores');
        this.MyKnowledgeStorePermission = this.authservice.getAccessList('Content');
        this.WebSourcePermission = this.authservice.getAccessList('WebSources');
    }

    checkWidth() {
        const width = window.innerWidth;
        //    console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    // searchStringChange(event: any) {
    //     const gyanTitle = event.trim();
    //     console.log('the title is', event);
    //     this.searchStr = gyanTitle;
    // }

    getCheckedItemListGKS() {
        const sources = localStorage.getItem('sources');
        const parsedSources = sources ? JSON.parse(sources) : {};
        if (parsedSources.knowledgeStoreIds) {
            this.checkedList = Object.keys(parsedSources.knowledgeStoreIds);
            console.log(this.checkedList); // This will log the array of keys from knowledgeStoreIds
        } else {
            console.log('knowledgeStoreIds not found');
        }
        // console.log('WebURLArray', this.checkedList, this.selectedWebURLArray);
        this.setTheSliderValue();
        if (this.searchStr !== '' && this.localStorageService.getItem('sliderRange')) this.value = this.localStorageService.getItem('sliderRange');
        this.checksubmitGyanButtonValidation();
        this.getCheckedItemListMKS();
    }

    getCheckedItemListMKS() {
        const sources = localStorage.getItem('sources');
        const parsedSources = sources ? JSON.parse(sources) : {};
        if (parsedSources.repoIds) {
            this.checkedRepoIds = Object.keys(parsedSources.repoIds);
            console.log(this.checkedRepoIds); // This will log the array of keys from knowledgeStoreIds
        } else {
            console.log('RepoIds not found');
        }
        // this.checkedRepoIds = Object.keys(sources.knowledgeStoreIds);
        this.checksubmitGyanButtonValidation();
    }

    checkurls() {
        return this.webURLArray?.length > 0 || this.ignorewebURLArray?.length > 0;
    }

    selectedWeb(webURL: string, event: any) {
        this.selectedWebURLArray = this.webURLArray;
        if (event.target.checked) {
            this.googleChecked = true;
            if (!this.selectedWebURLArray.includes(webURL)) {
                this.selectedWebURLArray.push(webURL);
                if (!this.webURLArray.includes(webURL)) {
                    this.webURLArray.push(webURL);
                }
            } else {
                this.toastr.warning('URL already exists in the list');
            }
            this.setTheSliderValue();
        } else {
            this.googleChecked = false;
            const index = this.selectedWebURLArray.findIndex((x: any) => x === webURL);
            if (index !== -1) this.selectedWebURLArray.splice(index, 1);
            this.setTheSliderValue();
        }
        const obj = {
            prioritizeDomains: [...new Set([...this.selectedWebURLArray, ...this.webURLArray])],
        };

        this.prioritizeDomains = obj.prioritizeDomains;
        if (this.searchStr !== '') this.updateLocalStorage();
        this.checksubmitGyanButtonValidation();
    }

    setTheSliderValue() {
        if (this.isDrafLoaded) {
            this.value = this.value;
            return;
        }
        if (this.checkedList.length > 0 && (this.selectedWebURLArray.length > 0 || this.checkurls())) this.value = 50;
        else this.value = 25;
        //this.value = 25;
    }
    onChangeSlider(value: number) {
        localStorage.setItem('sliderRange', JSON.stringify(value));
    }

    // normalizeUrl(url: string) {
    //     // Remove the protocol (http:// or https://) and "www." if it exists
    //     let normalizedUrl = url.replace(/^https?:\/\//, '').replace(/^www\./, '');
    //     return normalizedUrl;
    // }
    normalizeUrl(url: string): string {
        // Immediately return the normalized URL by chaining the replace() methods
        return url.replace(/^https?:\/\//, '').replace(/^www\./, '');
    }

    addWebURLArray() {
        if (this.webURL == 'https://www.google.com') {
            this.google = true;
        }
        this.webURL = this.webURL.trim();
        const targetNormalized = this.normalizeUrl(this.webURL.trim());
        // Check if the target domain is in the array
        const exists = this.ignorewebURLArray.some((url: string) => this.normalizeUrl(url) === targetNormalized);

        if (exists) {
            this.toastr.warning('already exists in the ignored website list');
        } else {
            if (!this.isURLValid(this.webURL)) {
                this.toastr.error('Please add valid Website URL');
            } else {
                if (!this.webURLArray.includes(this.webURL)) {
                    this.webURLArray.push(this.webURL);
                    if (!this.selectedWebURLArray.includes(this.webURL)) {
                        this.selectedWebURLArray.push(this.webURL);
                        this.cd.detectChanges();
                    }
                    this.cd.detectChanges();
                    console.log('the selected url is pushed', this.webURLArray);
                } else {
                    console.log('the selected url is already exists', this.webURLArray);
                    this.toastr.warning('URL already exists in the list');
                }
                this.webURL = null;
            }
        }
        this.checksubmitGyanButtonValidation();
        // this.checkEmptyUrl();
        const obj = {
            prioritizeDomains: [...new Set([...this.selectedWebURLArray, ...this.webURLArray])],
        };
        this.prioritizeDomains = obj.prioritizeDomains;
        if (this.searchStr !== '') this.updateLocalStorage();
        this.setTheSliderValue();
    }

    updateLocalStorage() {
        const sources = this.localStorageService.getItem('sources');
        if (sources) {
            sources.favouriteWebsites = this.selectedWebURLArray;
            sources.dispreferredWebsites = this.ignorewebURLArray;
            this.localStorageService.setItem('sources', sources);
        }
    }

    IgnoreWebURLArray() {
        this.IgnorewebURL = this.IgnorewebURL.trim();
        const targetNormalized = this.normalizeUrl(this.IgnorewebURL);
        // Check if the target domain is in the array
        const exists = this.webURLArray.some((url: string) => this.normalizeUrl(url) === targetNormalized);

        if (exists) {
            this.toastr.warning('already exists in the preferred website list');
        } else {
            if (!this.isURLValid(this.IgnorewebURL)) {
                this.toastr.error('Please add valid Website URL');
            } else {
                if (!this.ignorewebURLArray.includes(this.IgnorewebURL)) {
                    this.ignorewebURLArray.push(this.IgnorewebURL);
                } else {
                    this.toastr.warning('URL already exists in the list');
                }
                this.IgnorewebURL = null;
            }
        }
        // this.checkEmptyIgnoreUrl();
        this.checksubmitGyanButtonValidation();

        const obj = {
            deprioritizeDomains: [...new Set([...this.selectedIgnoreWebURLArray, ...this.ignorewebURLArray])],
        };
        this.deprioritizeDomains = obj.deprioritizeDomains;
        if (this.searchStr !== '') this.updateLocalStorage();
        this.setTheSliderValue();
    }

    checkEmptyUrl() {
        if (this.webURL.trim() == '') {
            this.toastr.error('Please add Website URL');
            this.webURL = '';
            return false; // Returns false if the URL is empty
        }
        return true; // Returns true if the URL is not empty
    }

    checkEmptyIgnoreUrl() {
        if (this.IgnorewebURL.trim() == '') {
            this.toastr.error('Please add Website URL');
            this.IgnorewebURL = '';
            return false; // Returns false if the URL is empty
        }
        return true; // Returns true if the URL is not empty
    }

    isURLValid(url: string): boolean {
        try {
            const parsedURL = new URL(url);
            return parsedURL.protocol === 'http:' || parsedURL.protocol === 'https:';
        } catch (error) {
            return false;
        }
    }

    editWebURL(editURL: any) {
        if (editURL == 'https://www.google.com') {
            console.log("can't edit google");
        } else {
            this.webURL = editURL;
            // this.checkEmptyUrl();
            if (!this.isURLValid(this.webURL)) {
                this.toastr.error('Please add valid Website URL');
            } else {
                if (this.webURLArray.includes(this.webURL)) {
                    const index = this.webURLArray.indexOf(editURL);
                    this.webURLArray.splice(index, 1);
                }
                if (this.selectedWebURLArray.includes(this.webURL)) {
                    const index = this.selectedWebURLArray.indexOf(editURL);
                    this.selectedWebURLArray.splice(index, 1);
                }
            }
        }
        if (this.searchStr !== '') this.updateLocalStorage();
        this.checksubmitGyanButtonValidation();
    }

    editIgnoreWebURL(editURL: any) {
        this.IgnorewebURL = editURL;
        // this.checkEmptyIgnoreUrl();
        if (!this.isURLValid(this.IgnorewebURL)) {
            this.toastr.error('Please add valid Website URL');
        } else {
            const index = this.ignorewebURLArray.indexOf(editURL);
            this.ignorewebURLArray.splice(index, 1);
        }
        if (this.searchStr !== '') this.updateLocalStorage();
        this.checksubmitGyanButtonValidation();
    }

    removeWebURL(removeItem: any) {
        if (removeItem == 'https://www.google.com') {
            this.google = false;
        }
        if (this.selectedWebURLArray.includes(removeItem)) {
            const indexinSelected = this.selectedWebURLArray.indexOf(removeItem);
            this.selectedWebURLArray.splice(indexinSelected, 1);
        }
        if (this.webURLArray.includes(removeItem)) {
            const index = this.webURLArray.indexOf(removeItem);
            this.webURLArray.splice(index, 1); // Removes one element, starting from index
        }
        const obj = {
            prioritizeDomains: [...new Set([...this.selectedWebURLArray, ...this.webURLArray])],
        };
        this.prioritizeDomains = obj.prioritizeDomains;
        if (this.searchStr !== '') this.updateLocalStorage();
        this.setTheSliderValue();
        this.checksubmitGyanButtonValidation();
    }

    removeIgnoreWebURL(removeItem: any) {
        const index = this.ignorewebURLArray.indexOf(removeItem);
        this.ignorewebURLArray.splice(index, 1); // Removes one element, starting from index
        const obj = {
            deprioritizeDomains: [...new Set([...this.selectedIgnoreWebURLArray, ...this.ignorewebURLArray])],
        };
        this.deprioritizeDomains = obj.deprioritizeDomains;
        if (this.searchStr !== '') this.updateLocalStorage();
        this.setTheSliderValue();
        this.checksubmitGyanButtonValidation();
    }

    checkValidationForSubtopicGKSandMKS(topic: any): boolean {
        let isValid = false;
        //console.log(topic);
        // main topic level
        if (topic && topic.sourcesSubTopic) {
            const favouriteWebsitesCount = topic.sourcesSubTopic.favouriteWebsites?.length || 0;
            const includeSubTopicCount = Object.values(topic.sourcesSubTopic.includeSubTopic || {}).filter(Boolean).length;
            // console.log('favouriteWebsitesCount', favouriteWebsitesCount);
            // console.log('includeSubTopicCount', includeSubTopicCount);
            // If either condition is met, set isValid to true
            if (favouriteWebsitesCount > 0 || includeSubTopicCount > 0) {
                return true;
            }
        }

        // recursively check subtopics for validation
        if (topic && Array.isArray(topic.subtopics)) {
            for (const subtopic of topic.subtopics) {
                if (this.checkValidationForSubtopicGKSandMKS(subtopic)) {
                    // console.log('inside recursive function');
                    isValid = true;
                    break; // found true then no need
                }
            }
        }

        return isValid;
    }

    checksubmitGyanButtonValidation() {
        console.log('checksubmitGyanButtonValidation called');
        const topicOutlineLocal = this.localStorageService.getItem('topicOutline');
        const result = this.checkValidationForSubtopicGKSandMKS(topicOutlineLocal);
        console.log('result ', result);
        console.log('the validations', this.selectedWebURLArray, this.selectedIgnoreWebURLArray, this.checkedList, this.checkedRepoIds);
        if (result || this.selectedWebURLArray.length > 0 || this.selectedIgnoreWebURLArray.length > 0 || this.checkedList.length > 0 || this.checkedRepoIds.length > 0) {
            //|| this.checkedList.length > 0 || this.checkedRepoIds.length > 0
            console.log('inside if');
            this.disableSubmit = true;
            if (this.isDrafLoaded) this.searchStr = topicOutlineLocal?.name;
        } else {
            console.log('inside else');
            this.disableSubmit = false;
        }
    }

    isDraftNameEmpty(): boolean {
        // Use trim() to remove leading and trailing whitespaces
        return this.draftname.trim() === '';
    }

    saveDraft() {
        //setting latest updated gyan main title
        const topicOutline = this.localStorageService.getItem('topicOutline');
        if (topicOutline?.name) this.searchStr = topicOutline.name;

        // this.isLoading = true;
        if (this.searchStr) {
            //this.disableSubmit = false;
            this.validateCount();
            const topicOutlineLocal = this.localStorageService.getItem('topicOutline');
            const topicOutline = this.removeProperties(topicOutlineLocal);
            const sources = this.localStorageService.getItem('sources');
            sources.favouriteWebsites = this.selectedWebURLArray;
            sources.dispreferredWebsites = this.deprioritizeDomains;
            sources.repoAvailable = Object.keys(sources.repoIds).length > 0 ? true : false;
            console.log('-------------', sources);

            const payload = {
                topicOutline: topicOutline,
                sources: sources, //transformData.sources,
                config: {
                    //add validations here
                    maxSearchCount: this.maxSearchCount,
                    maxSearchCountRepo: this.maxSearchCountRepo,
                    generateMultidocSummary: 'true',
                    consolidateNow: false,
                },
            };
            const currentUser = this.localStorageService.getItem('userDetails');
            console.log('currentUser', currentUser);
            console.log('payload', payload);
            const objPayload: any = {
                personId: currentUser.personId,
                data: JSON.stringify(payload),
                name: this.draftname.trim(),
            };

            if (this.isDrafLoaded) {
                objPayload.id = this.draft && this.draft?.id;
            }
            console.log('the payload is', objPayload);
            //return
            this.isLoading = true;

            if (this.searchStr) {
                this.creategyanservice.saveDraftGyan(objPayload).subscribe({
                    next: (response: any) => {
                        this.isLoading = false;
                        if (this.modalRef) {
                            this.modalRef.close(); // Closes the modal
                        }

                        //this.disableSubmit = true;
                        this.toastr.success(response.message);
                        this.clearLocalStorageData();
                        this.commonservice.setShowDraftListPage(true);
                    },
                    error: (error: HttpErrorResponse) => {
                        const topicOutline = this.localStorageService.getItem('topicOutline');
                        const data = { topicOutline: topicOutline, isDraft: true };
                        this.commonservice.setCallUseAsTemplate(data);
                        //this.disableSubmit = true;
                        this.isLoading = false;
                        if (error.status === 406) {
                            this.toastr.error('Draft with same name exists');
                        } else {
                            this.toastr.error('Failed to save draft');
                        }
                        console.log('Error: ', error.message);
                    },
                    complete: () => {},
                });
            } else {
                this.isLoading = false;
            }
        } else {
            //this.toastr.warning('Please select any one of the option');
        }
    }

    cancelDraft() {
        if (this.modalRef) {
            this.modalRef.close(); // Closes the modal
        }
    }

    opensaveDraftModal() {
        this.draftname = this.isDrafLoaded ? this.draft.name : '';
        this.modalRef = this.modalService.open(this.saveDraftModal, {
            centered: true,
            windowClass: 'custom-modal-class-savedraft',
            size: 'sm',
        });
    }

    SubmitGyan() {
        //setting latest updated gyan main title
        const topicOutline = this.localStorageService.getItem('topicOutline');
        if (topicOutline?.name) this.searchStr = topicOutline.name;

        //Add the validations here
        console.log('validation lists', this.checkedList, this.selectedWebURLArray, this.selectedIgnoreWebURLArray, this.checkedRepoIds);
        // this.isLoading = true;
        if (this.disableSubmit === true) {
            this.disableSubmit = false;
            this.validateCount();
            console.log('the value is', this.value);
            console.log('submit gyan success', this.value);

            const topicOutlineLocal = this.localStorageService.getItem('topicOutline');
            const topicOutline = this.removeProperties(topicOutlineLocal);
            console.log('-------------', topicOutline);
            // if (topicOutline.subtopics.length > 0) {
            //     topicOutline.isArticleCountToZero = true;
            // }
            const sources = this.localStorageService.getItem('sources');
            sources.favouriteWebsites = this.selectedWebURLArray;
            sources.dispreferredWebsites = this.deprioritizeDomains;
            sources.repoAvailable = Object.keys(sources.repoIds).length > 0 ? true : false;
            console.log('-------------', sources);

            const payload = {
                topicOutline: topicOutline,
                sources: sources, //transformData.sources,
                config: {
                    //add validations here
                    maxSearchCount: this.maxSearchCount,
                    maxSearchCountRepo: this.maxSearchCountRepo,
                    generateMultidocSummary: 'true',
                    consolidateNow: false,
                },
            };
            console.log('the payload is', payload);
            if (this.searchStr) {
                this.submitgyanService.initiateAdvancedQueries(payload, this.authservice.getGyanCookie()).subscribe({
                    next: (response: any) => {
                        this.disableSubmit = true;
                        this.checkedList.forEach((element: { id: string }) => {
                            if (element.id == '6c8c9bb8-c587-33bb-9f36-d395d20f9251+03ac025a-6eef-387f-9912-269b1478ad8c') {
                                console.log('the value is true');
                                this.creategyanservice.pksSelected = true;
                            }
                        });
                        const gyanData = { gyanName: this.searchStr, gyanId: response.topic.topicId, gyanType: 'gyan', gyanCreatedNow: 'yes', gyanStatus: 'SUBMITTED' };

                        this.localStorageService.setItem('gyanData', gyanData);
                        this.localStorageService.setItem('rootGyanId', response.topic.topicId);
                        console.log('gyanData localStorage is', gyanData);
                        this.toastr.success('Gyan initiated successfully');
                        console.log('----result from old gyan', response);
                        this.commonservice.setCreateGyanInitiated(true);
                        this.commonservice.setRefreshAdvancedQueries(true);
                        setTimeout(() => {
                            this.commonservice.setCreateGyanInitiated(false);
                        }, 100);
                        //this.commonservice.setgotoDashboard(true);

                        this.clearLocalStorageData();
                        if (this.draft && this.draft.id) {
                            this.creategyanservice.deleteDraft(this.draft.id).subscribe((data) => {
                                console.log(data);
                                this.commonservice.setDraftLoaded(false);
                            });
                        }
                    },
                    error: (error: HttpErrorResponse) => {
                        this.disableSubmit = true;
                        this.toastr.error('Gyan submission failed');
                        console.log('Error: ', error.message);
                    },
                    complete: () => {},
                });
            }
        } else {
            this.toastr.warning('Please select any one of the option');
        }
    }

    clearLocalStorageData() {
        console.log('clearLocalStorageData called');
        this.localStorageService.removeItem('topicOutline');
        this.localStorageService.removeItem('sources');
        this.localStorageService.removeItem('myKnowledgeStore');
        this.localStorageService.removeItem('gyanKnowledgeStore');
        this.localStorageService.removeItem('subtopicSource_myKnowledgeStore');
        this.localStorageService.removeItem('subtopicSource_gyanKnowledgeStore');
        this.localStorageService.removeItem('sliderRange');
    }

    removeProperties(topic: any) {
        // Delete the properties level and showAddIcon which is used for showing it in UI but no need in API Payload
        delete topic.level;
        delete topic.showAddIcon;
        delete topic.ParentList;
        delete topic?.viewIndex;
        delete topic?.ParentValueChanged;
        delete topic?.isTemplate;

        // If there are subtopics, then function recursively remove 2 variables.
        if (topic.subtopics && topic.subtopics.length > 0) {
            topic.subtopics.forEach((subtopic: any) => this.removeProperties(subtopic));
        }
        return topic;
    }

    validateCount() {
        if (this.checkedList.length > 0) {
            //internet repo
            if (this.selectedWebURLArray.length > 0 || this.selectedIgnoreWebURLArray.length > 0) {
                //both internet and web
                this.maxSearchCount = Math.floor(this.value / 2);
                this.maxSearchCountRepo = Math.ceil(this.value / 2);
            } else {
                //only internet
                this.maxSearchCountRepo = this.value;
            }
        } //No internet repo
        else {
            if (this.selectedWebURLArray.length > 0 || this.selectedIgnoreWebURLArray.length > 0) {
                //only web
                this.maxSearchCount = this.value;
            }
        }
    }

    displaytooltipMobile() {
        this.displayTooltip = !this.displayTooltip;
    }

    hideTooltip() {
        console.log('clicked outside');
        this.displayTooltip = false;
    }

    ngOnDestroy() {
        this.showAdvancyQueryFormPage.unsubscribe();
        this.callTopicName.unsubscribe();
        this.validationForSubmitGyanFromSubtopic.unsubscribe();
        this.getTemplateSubsSources.unsubscribe();
        this.getTemplateSubsConfig.unsubscribe();
        this.getTemplateSubsTopicOutline.unsubscribe();
        this.resetGyan.unsubscribe();
        this.draftItem.unsubscribe();
    }
}
